import { ArsTableCellData, ArsTableRow } from "../interface";

/**
 * Retrieves all cell data for a specified column from the given table rows.
 *
 * @param tableRows - Array of table rows or null
 * @param columnId - ID of the column to retrieve cells for
 * @returns Array of cell data for the specified column
 */
export const getColumnCells = <T>(
  tableRows: ArsTableRow<T>[] | null,
  columnId: string,
): ArsTableCellData<T>[] => {
  if (!tableRows) return [];
  return tableRows
    .map((row) => row.arsTableCells.find((cell) => cell.columnId === columnId))
    .filter((cell) => cell !== undefined);
};
